var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoppel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.4 56.7",
    style: {
      enableBackground: "new 0 0 113.4 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFE400;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#005FAA;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.4,
    y: 19.9,
    className: "st0",
    width: 61.8,
    height: 16.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,19.9h20.6c0.4,0,0.8,0.4,0.8,0.9v15.1c0,0.5-0.4,0.9-0.8,0.9H15c-0.4,0-0.8-0.4-0.8-0.9V20.8 C14.2,20.3,14.5,19.9,15,19.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "30.5,30.8 33.4,30.8 33.4,33.3 32.4,33.3 32.4,32.4 31.5,32.4 31.5,33.3 30.5,33.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.3,30.6H30v0h-7.4c0.1,0.2,0.2,0.5,0.2,0.8c0,1.1-0.9,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.8 c-0.2,0.1-0.5,0.1-0.7,0.1c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9c0.3,0,0.5,0,0.7,0.1c0.1-1,0.9-1.8,1.9-1.8 c1.1,0,1.9,0.9,1.9,1.9c0,0.3-0.1,0.6-0.2,0.8h11.7V30.6 M20.8,27.1c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9 c-0.5,0-0.9-0.4-0.9-0.9C20,27.5,20.3,27.1,20.8,27.1 M18.3,28.9c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9 c-0.5,0-0.9-0.4-0.9-0.9C17.4,29.3,17.8,28.9,18.3,28.9 M20.8,30.6c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9 c-0.5,0-0.9-0.4-0.9-0.9C20,31,20.3,30.6,20.8,30.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.9,27c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.4-1.1-2.4-2.5C53.5,28.1,54.6,27,55.9,27  M55.9,25.3c2.3,0,4.1,1.9,4.1,4.1c0,2.3-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.9-4.1-4.1C51.8,27.2,53.7,25.3,55.9,25.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.2,31.8H48c-1.9-0.1-3.1-1.8-3-3.7c0.2-1.9,1.4-3.2,3.4-3.3c1,0,1.8,0,2.8,0l0-0.8l0-1 c-1.5,0-3.1-0.1-4.1,0.1c-2.2,0.3-3.9,2.9-3.9,5.2c0,2.9,2.3,5.2,5.1,5.2c1,0,2,0,2.9,0C51.2,31.8,51.2,32.4,51.2,31.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.3,32.7l0,4.1h-1.5l0-7.3c0-2.3,1.9-4.1,4.1-4.1c2.3,0,4.1,1.9,4.1,4.1c0,2.3-1.9,4.1-4.1,4.1 C63.9,33.6,63,33.2,62.3,32.7 M64.8,27c1.4,0,2.6,1.2,2.6,2.5c0,1.3-1.1,2.5-2.6,2.5c-1.4,0-2.4-1-2.4-2.4 C62.4,28.1,63.4,27,64.8,27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.2,32.7l0,4.1h-1.5l0-7.3c0-2.3,1.9-4.1,4.1-4.1c2.3,0,4.1,1.9,4.1,4.1c0,2.3-1.9,4.1-4.1,4.1 C72.8,33.6,71.9,33.2,71.2,32.7 M73.7,27c1.4,0,2.6,1.1,2.6,2.5c0,1.4-1.1,2.5-2.6,2.5c-1.4,0-2.4-1-2.4-2.4 C71.3,28.1,72.3,27,73.7,27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.3,30.6l3.3-3.4c-0.3-0.1-0.4-0.2-0.9-0.3c-1.5,0-2.6,1.1-2.6,2.5C80.1,29.9,80.1,30.2,80.3,30.6  M85.4,27.8l-3.8,3.9c-0.1,0,0.4,0.4,1.2,0.3h2.9l0,1.6h-2.6c-2.5,0.1-4.6-1.7-4.6-4.1c-0.1-2.3,1.9-4.2,4.3-4.2 c1.3,0,2.5,0.9,2.6,1.2C85.7,26.8,85.8,27.5,85.4,27.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.4,23.2h1.5v6.2c0.1,1,0.5,1.6,0.9,2c0.3,0.3,0.8,0.4,1.3,0.4l2.2,0v1.7l-1.9,0c-1,0-2.1-0.2-2.7-0.8 c-0.8-0.8-1.4-1.8-1.4-3.7L86.4,23.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoppel);
export default __webpack_public_path__ + "static/media/coppel.0a308e794ca8681e382874accd035251.svg";
export { ForwardRef as ReactComponent };